import React from "react"
import Layout from "../../Components/Shared/Layout/Layout"
import "./DeadLinks.css"

const DeadLinks = () => {

    return(
    <>
    <Layout>
        <div className="dead-image-div"></div>
    </Layout>
    </>
    )
}

export default DeadLinks